import React, { useState } from "react";
import { Dimmer, Loader, Icon } from "semantic-ui-react";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import { useSize } from "react-lib/utils/hooksUtils";
import LineLoginButton from "react-lib/apps/IsHealth/Common/Line/LoginButton";
import FacebookLoginButton from "react-lib/apps/IsHealth/Common/FacebookLogin/FBLoginButton";
import AppleIDLoginButton from "react-lib/apps/IsHealth/Common/AppleIDLogin/LoginButton";
import settings from "../config/config";
import { facebookAppId, versionFacebook } from "./MainPatient";

// interface LoginProps {
//  onLoginSuccess?: () => void;
//  IsAnonymousLogin?: boolean;
//  OnAnonymousLoginSuccess?: () => void;
//  onLoginFacebookSiteSuccess?: () => void;
//  onHaveApiToken?: () => void;
//  onHaveAnonymousLogin?: () => void;
//  openSetupEmail?: () => void;
//  redirectUri?: string;
//  device_id?: string;
//  subscription?: Record<string,any>;
//  loginLine?: () => void;
// }

const DEFAULT_PROPS = {
  onLoginSuccess: () => {},
  IsAnonymousLogin: false,
  OnAnonymousLoginSuccess: () => {},
  onLoginFacebookSiteSuccess: () => {},
  onHaveApiToken: () => {},
  onHaveAnonymousLogin: () => {},
  openSetupEmail: () => {},
  detail: null,
  redirectUri: null,
  device_id: null,
  subscription: null,
  loginLine: () => {},
};

const Login = (propsParam) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value]) => value !== undefined)),
  };
  const history = useHistory();
  const lineButtonRef = React.useRef();
  const { height } = useSize(lineButtonRef);
  const [isLoading, setIsLoading] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const show_apple = params.get("apple");

  const handleResponseFacebook = async ({ data, deviceId, fbResponse }: any) => {
    if (!("email" in data)) {
      alert("User ไม่ได้อนุญาติ ให้เข้าถึง email-address");
      props.openSetupEmail();
      return;
    }

    const [response, error] = await props.controller?.getRegisterByTokenFacebook({
      accessToken: fbResponse.authResponse?.accessToken,
      app: settings.APP_NAME ? settings.APP_NAME : "ishealth",
      device_id: deviceId,
    });

    if (response) {
      props.onLoginSuccess(response);
    } else {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    console.log({
      cookies: Cookies.get("apiToken"),
      props: props.apiToken,
      oaChannelId: Cookies.get("oaChannelId"),
    });
    if ((Cookies.get("apiToken") || props.apiToken) && !props.alreadyRedirect) {
      console.log(" useEffect props.onHaveApiToken() ");
      props.onHaveApiToken();
    }
  }, [props.apiToken, Cookies.get("apiToken")]);

  React.useEffect(() => {
    console.log(
      " uesEffect",
      Cookies.get("apiToken"),
      "props.IsAnonymousLogin",
      props.IsAnonymousLogin
    );
    if (props.IsAnonymousLogin && Cookies.get("apiToken") === "anonymous") {
      props.onHaveAnonymousLogin();
    }
  }, []);

  const gotoLineLogin = () => {
    props.loginLine();
  };

  return (
    <Dimmer.Dimmable dimmed={isLoading || props.loading}>
      <div className="Login">
        <div className="fbLogin">
          {props.detail}
          <LineLoginButton
            ref={lineButtonRef}
            onClick={gotoLineLogin}
            style={{ width: "90%", lineHeight: "32px", display: "flex", alignItems: "center" }} // 32px is size of Line Logo Image
            logoStyle={{ float: "left" }}
          />
          <br />
          <br />
          <FacebookLoginButton
            style={{
              height,
              width: "90%",
              lineHeight: "32px",
              display: "block",
            }}
            appId={facebookAppId}
            deviceId={props.device_id}
            version={versionFacebook}
            onCallback={handleResponseFacebook}
            onLoading={setIsLoading}
            onSiteSuccess={props.onLoginFacebookSiteSuccess}
            logoStyle={{ height: height, width: height, padding: "5px", float: "left" }} // 32px is size of Line Logo Image
          />
          <br />
          <br />
          <div
            className="email-login-button"
            onClick={() => {
              history.push("/EmailLogin/");
            }}
          >
            <Icon style={{ padding: "5px", float: "left" }} name="mail" size="large" />
            <span>ลงชื่อเข้าใช้งานด้วยอีเมล</span>
          </div>
          <br />
          <br />
          {show_apple ? <AppleIDLoginButton /> : <></>}
        </div>
      </div>
      <Dimmer active={isLoading} inverted>
        <Loader size="massive">{"Loading"}</Loader>
      </Dimmer>
    </Dimmer.Dimmable>
  );
};

export default Login;
